var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFromTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "nonzero",
    stroke: "#F6B119",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.096 18.442H7.41c-1.687 0-4.873-.847-4.873-4.056 0-3.21 3.186-4.056 4.873-4.056h4.161c.14 0 3.468-.046 3.468-2.66 0-2.614-3.327-2.66-3.468-2.66H6.885a.706.706 0 0 1-.497-.205.695.695 0 0 1 .497-1.191h4.686c1.687 0 4.873.846 4.873 4.056 0 3.209-3.186 4.056-4.873 4.056h-4.16c-.141 0-3.468.046-3.468 2.66 0 2.614 3.327 2.66 3.467 2.66h4.686c.186 0 .365.074.497.205a.695.695 0 0 1 0 .986.705.705 0 0 1-.497.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28 7.567A3.325 3.325 0 0 1 2.45 7a3.289 3.289 0 0 1-1.206-1.479 3.261 3.261 0 0 1 .735-3.569 3.331 3.331 0 0 1 3.602-.7c.602.25 1.117.67 1.48 1.21a3.266 3.266 0 0 1-.424 4.153 3.31 3.31 0 0 1-2.357.952zm0-5.172c-.37 0-.733.11-1.041.314a1.848 1.848 0 0 0-.284 2.862 1.879 1.879 0 0 0 2.042.404c.343-.141.636-.38.841-.686a1.85 1.85 0 0 0-.84-2.752 1.886 1.886 0 0 0-.718-.142zM14.701 21a3.326 3.326 0 0 1-1.84-.549 3.289 3.289 0 0 1-1.223-1.472 3.261 3.261 0 0 1 .711-3.581 3.331 3.331 0 0 1 3.606-.716c.606.248 1.123.669 1.487 1.209a3.267 3.267 0 0 1-.408 4.144 3.32 3.32 0 0 1-2.333.965zm0-5.172c-.37 0-.733.109-1.041.313a1.849 1.849 0 0 0-.284 2.862 1.88 1.88 0 0 0 2.043.404c.342-.14.635-.38.84-.685a1.85 1.85 0 0 0-.232-2.35 1.881 1.881 0 0 0-1.326-.544z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromTo);
export default __webpack_public_path__ + "static/media/from_to.60cc7dbf65937e35970e13c2f0862931.svg";
export { ForwardRef as ReactComponent };